import { version } from '@raiz/package.json';

export const environment = {
  production: false,
  urlApiArgon : 'https://argon-api.dev.sla03.devtest.aws.scania.com',
  redirectUri: 'https://argon.dev.sla03.devtest.aws.scania.com/',
  protectedResource: 'https://argon-api.dev.sla03.devtest.aws.scania.com',
  AppVersion : ` - Dev`,

};
